'use client';

import Link from 'next/link';

export default function CCPALink() {
  return (
    <Link
      href="/privacy#do-not-sell"
      className="text-xs text-white/50 hover:text-white transition-colors"
    >
      Do Not Sell My Personal Information
    </Link>
  );
}
